import {
  getVesselSearchData,
  updateVesselPreReference,
  updateEstimatedTimeStamp
} from "@/common/service/apiaggregator/apiAgreegatorService";
import {
  getVesselNotificationDetails,
  getVesselReferences,
  getBrandDetails,
  updateSubmittedManifest,
  getNotificationDetails,
  submitManualApproval,
  updateVesselCertificateDetails
} from "@/common/service/apiaggregator/manifestAgreegatorService";
import { convertToLowerCase } from "@/common/utils/generic/commonHelper.js";
import { constants } from "@/lib/CONSTANTS.js";
const state = {
  vesselList: [],
  multipleBrandcheck: [],
  complianceDetailsList: [],
  vesselPreNotificationList: [],
  vesselNotificationDetailsList: [],
  loadContainerDetails: {},
  emptyContainerDetails: {},
  loadContainerList: [],
  containerList: [],
  cargoList: [],
  cargoDetails: {},
  peopleDetails: {},
  peopleContainerDetails: {
    captainName: "",
    noOfCrew: "",
    noOfPassengers: ""
  },
  vesselCertificateDetails: {},
  vesselCertificateList: [],
  multipleBrandcheckLoader: false,
  vesselNotificationDetailsListLoader: false,
  vesselPreNotificationListLoader: false,
  notificationDetailsLoader: false,
  notificationDetails: "",
  compId: "",
  manualSub: [],
  pFlag: false,
  compPort: "",
  loadPort: "",
  complianceType: "",
  currentGsisKey: "",
  vesselCode: "",
  vanVSAPartnerList: constants.pageSettings.vanVSAPartner,
  manifestViewType: "list"
};

const mutations = {
  setCurrentGsisKey(state, data) {
    state.currentGsisKey = data;
  },
  setVesselList(state, result) {
    state.vesselList = result;
  },
  setVesselNotificationDetailsList(state, result) {
    state.vesselNotificationDetailsList = result;
  },
  setNotificationDetails(state, result) {
    state.notificationDetails = result;
  },
  setVesselPreNotificationList(state, result) {
    state.containerList = [];
    if (result && result.vesselReferences) {
      for (const item of result.vesselReferences) {
        switch (convertToLowerCase(item.type)) {
          case "load containers": {
            state.loadContainerDetails = item;
            state.loadContainerList = item.references;
            state.containerList = state.containerList.concat(item.references);
            break;
          }
          case "empty containers": {
            state.emptyContainerDetails = item;
            state.emptyContainerList = item.references;
            state.containerList = state.containerList.concat(item.references);
            break;
          }
          case "cargo": {
            state.cargoDetails = item;
            state.cargoList = item.references;
            break;
          }
          case "people": {
            state.peopleDetails = item;
            state.peopleContainerDetails = item.references[0];
            break;
          }
        }
      }
      if (result.vesselCertificateRule && result.vesselCertificateRule.vesselCertificates.length > 0) {
        state.vesselCertificateDetails = result.vesselCertificateRule;
        state.vesselCertificateList = result.vesselCertificateRule.vesselCertificates;
        for (const item of state.vesselCertificateList) {
          if (item.expiryDate && item.expiryDate != "" && item.expiryDate != null) {
            const expDateArry = item.expiryDate.split("-");
            item.expDate = expDateArry[2] + "/" + expDateArry[1] + "/" + expDateArry[0];
          } else {
            item.expDate = "";
          }
        }
      }
    } else {
      state.vesselPreNotificationList = result;
      state.containerList = [];
      state.containerList = [];
      state.cargoList = [];
      state.vesselCertificateList = [];
    }
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "hasError" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setComplianceId(state, value) {
    state.compId = value;
  },
  setManualStatus(state, result) {
    state.manualSub = result;
  },
  setCompliancePort(state, value) {
    state.compPort = value;
  },
  setComplianceType(state, value) {
    state.complianceType = value;
  },
  setVesselCode(state, value) {
    state.vesselCode = value;
  },
  setVoyageCode(state, value) {
    state.voyageCode = value;
  },
  setMultipleBrandcheck(state, value) {
    state.multipleBrandcheck = value;
  },
  setLoadPort(state, value) {
    state.loadPort = value;
  },
  setManifestViewType(state, value) {
    state.manifestViewType = value;
  }
};
const actions = {
  async fetchVesselList({ commit }, params) {
    commit("setVesselList", []);
    commit("setLoadingState", { type: "vesselList", value: true });
    try {
      const { manifest, countryCode } = params;
      let rawData,
        data = [];
      rawData = await getVesselSearchData(manifest, countryCode, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "vesselList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      commit("setVesselList", data);
      commit("setErrorState", { type: "vesselList", error: "" });
      commit("setLoadingState", { type: "vesselList", value: false });
    } catch (error) {
      commit("setVesselList", []);
      commit("setErrorState", { type: "vesselList", error });
      commit("setLoadingState", { type: "vesselList", value: false });
    }
  },
  async fetchVesselDetailsList({ commit }, newParams) {
    commit("setVesselNotificationDetailsList", []);
    commit("setLoadingState", { type: "vesselNotificationDetailsList", value: true });
    const { compId, compPort, gsisKey, complianceType } = newParams;
    try {
      let rawData,
        data = [],
        queryParams;
      queryParams = {
        gsisKey
      };
      rawData = await getVesselReferences(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "vesselNotificationDetailsList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      if (compId && compId.length > 0) {
        commit("setComplianceId", compId);
        commit("setCompliancePort", compPort);
        commit("setComplianceType", complianceType);
      }
      for (const mainItem of state.vanVSAPartnerList) {
        let counter = 0;
        for (const childItem of data.vesselReferences) {
          if (childItem.brand === mainItem) {
            counter++;
          }
        }
        if (counter === 0) {
          const item = {
            brand: mainItem,
            direction: "Import",
            maerskOwned: false,
            references: [
              {
                referenceName: "weight",
                referenceValue: ""
              },
              {
                referenceName: "Manifest Reference Number",
                referenceValue: ""
              }
            ]
          };
          data.vesselReferences.push(item);
        }
      }
      commit("setVesselNotificationDetailsList", data);
      commit("setCurrentGsisKey", gsisKey);
      commit("setErrorState", { type: "vesselNotificationDetailsList", error: "" });
      commit("setLoadingState", { type: "vesselNotificationDetailsList", value: false });
    } catch (error) {
      commit("setVesselNotificationDetailsList", []);
      commit("setErrorState", { type: "vesselNotificationDetailsList", error });
      commit("setLoadingState", { type: "vesselNotificationDetailsList", value: false });
    }
  },
  async fetchNotificationDetails({ commit }, queryParams) {
    commit("setNotificationDetails", {});
    commit("setLoadingState", { type: "notificationDetails", value: true });
    try {
      let rawData,
        data = [];

      if (queryParams.complianceId && queryParams.complianceId.length > 0) {
        commit("setComplianceId", queryParams.complianceId);
        commit("setCompliancePort", queryParams.compliancePort);
        commit("setComplianceType", queryParams.complianceType);
        commit("setVesselCode", queryParams.vesselCode);
        commit("setLoadPort", queryParams.loadPort);
        if (queryParams.voyageCode) {
          commit("setVoyageCode", queryParams.voyageCode);
        }
      }

      rawData = await getNotificationDetails(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "notificationDetails",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      if (data.references && data.references.length > 0) {
        for (const item of data.references) {
          item.oldValue = item.value;
        }
      }
      commit("setNotificationDetails", data);
      commit("setErrorState", { type: "notificationDetails", error: "" });
      commit("setLoadingState", { type: "notificationDetails", value: false });
    } catch (error) {
      commit("setVesselNotificationDetailsList", []);
      commit("setErrorState", { type: "notificationDetails", error });
      commit("setLoadingState", { type: "notificationDetails", value: false });
    }
  },
  async manualVANSubmission({ commit, dispatch }, cParm) {
    commit("setLoadingState", { type: "manualSub", value: true });
    try {
      let rawData;
      const { complianceId, complianceType } = cParm;

      const cmpParams = {
        complianceId,
        isSelectedAllBol: state.selectedAllBol ? true : false,
        complianceType
      };
      rawData = await updateSubmittedManifest(cmpParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "manualSub",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      }

      const newParams = {
        complianceId: state.compId,
        compliancePort: state.compPort,
        complianceType: state.complianceType,
        vesselCode: state.vesselCode,
        voyageCode: state.voyageCode,
        loadPort: ""
      };

      dispatch("fetchNotificationDetails", newParams);
      commit("setErrorState", { type: "manualSub", error: "" });
      commit("setLoadingState", { type: "manualSub", value: false });
    } catch (error) {
      commit("setErrorState", { type: "manualSub", error });
      commit("setLoadingState", { type: "manualSub", value: false });
    }
  },
  async fetchVesselPreNotificationsList({ commit }, newParams) {
    commit("setVesselPreNotificationList", []);
    commit("setLoadingState", { type: "vesselPreNotificationList", value: true });
    const { compId, compPort, complianceType, vesselCode, voyageCode } = newParams;
    try {
      let rawData,
        data = [],
        queryParams;
      queryParams = {
        compId,
        complianceType,
        vesselCode
      };
      rawData = await getVesselNotificationDetails(queryParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "vesselPreNotificationList",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      if (compId && compId.length > 0) {
        commit("setComplianceId", compId);
        commit("setCompliancePort", compPort);
        commit("setComplianceType", complianceType);
        commit("setVesselCode", vesselCode);
        if (voyageCode) {
          commit("setVoyageCode", voyageCode);
        }
      }
      commit("setVesselPreNotificationList", data);
      commit("setErrorState", { type: "vesselPreNotificationList", error: "" });
      commit("setLoadingState", { type: "vesselPreNotificationList", value: false });
    } catch (error) {
      commit("setVesselPreNotificationList", []);
      commit("setErrorState", { type: "vesselPreNotificationList", error });
      commit("setLoadingState", { type: "vesselPreNotificationList", value: false });
    }
  },
  async updatePreReference({ commit, dispatch }, params) {
    commit("setManualStatus", []);
    commit("setLoadingState", { type: "updatePre", value: true });
    try {
      let rawData,
        data = [];
      rawData = await updateVesselPreReference(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updatePre",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      const newParams = {
        compId: state.compId,
        compPort: state.compPort,
        complianceType: state.complianceType,
        vesselCode: state.vesselCode
      };

      dispatch("fetchVesselPreNotificationsList", newParams);
      commit("setManualStatus", data);
      commit("setErrorState", { type: "updatePre", error: "" });
      commit("setLoadingState", { type: "updatePre", value: false });
    } catch (error) {
      commit("setManualStatus", []);
      commit("setErrorState", { type: "updatePre", error });
      commit("setLoadingState", { type: "updatePre", value: false });
    }
  },
  async updateCertificateDetails({ commit, dispatch }, params) {
    commit("setManualStatus", []);
    commit("setLoadingState", { type: "updatePre", value: true });
    try {
      let rawData,
        data = [];
      rawData = await updateVesselCertificateDetails(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updatePre",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      const newParams = {
        compId: state.compId,
        compPort: state.compPort,
        complianceType: state.complianceType,
        vesselCode: state.vesselCode
      };

      dispatch("fetchVesselPreNotificationsList", newParams);
      commit("setManualStatus", data);
      commit("setErrorState", { type: "updatePre", error: "" });
      commit("setLoadingState", { type: "updatePre", value: false });
    } catch (error) {
      commit("setManualStatus", []);
      commit("setErrorState", { type: "updatePre", error });
      commit("setLoadingState", { type: "updatePre", value: false });
    }
  },
  // for brand details
  async brandDetailsData({ commit }, newparams) {
    commit("setMultipleBrandcheck", []);
    commit("setLoadingState", { type: "multipleBrandcheck", value: true });
    try {
      let rawData,
        data = [];

      const params = {
        complianceId: newparams.complianceId,
        loadPort: state.loadPort,
        consignmentType: newparams.consignmentType
      };

      rawData = await getBrandDetails(params, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "multipleBrandcheck",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      commit("setMultipleBrandcheck", data);
      commit("setErrorState", { type: "multipleBrandcheck", error: "" });
      commit("setLoadingState", { type: "multipleBrandcheck", value: false });
    } catch (error) {
      commit("setMultipleBrandcheck", []);
      commit("setErrorState", { type: "multipleBrandcheck", error });
      commit("setLoadingState", { type: "multipleBrandcheck", value: false });
    }
  },
  async updateVesselTimeStamp({ commit, dispatch }, estimatedDepartureDate) {
    commit("setManualStatus", []);
    commit("setLoadingState", { type: "updatePre", value: true });
    try {
      let rawData,
        data = [];
      const cmpParams = {
        complianceId: state.compId,
        alternateEstimatedTimeStamp: estimatedDepartureDate
      };
      rawData = await updateEstimatedTimeStamp(cmpParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        commit("setErrorState", {
          type: "updatePre",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }
      const newParams = {
        complianceId: state.compId,
        compliancePort: state.compPort,
        complianceType: state.complianceType,
        vesselCode: state.vesselCode,
        voyageCode: state.voyageCode,
        loadPort: ""
      };

      dispatch("fetchNotificationDetails", newParams);
      commit("setManualStatus", data);
      commit("setErrorState", { type: "updatePre", error: "" });
      commit("setLoadingState", { type: "updatePre", value: false });
    } catch (error) {
      commit("setManualStatus", []);
      commit("setErrorState", { type: "updatePre", error });
      commit("setLoadingState", { type: "updatePre", value: false });
    }
  },
  async manualManifestApproval({ commit, dispatch }, manualApprovalPayload) {
    commit("setManualStatus", []);
    commit("setLoadingState", { type: "manualApproval", value: true });
    try {
      let rawData,
        data = [];
      const {
        complianceId,
        status,
        enableManualApprovalOnRejection,
        enableBolStatusValidation
      } = manualApprovalPayload;

      const manualApprovalParams = {
        complianceId,
        status,
        enableManualApprovalOnRejection,
        enableBolStatusValidation
      };
      rawData = await submitManualApproval(manualApprovalParams, true);
      if (rawData.status > 200 && rawData.status <= 299) {
        data = [];
        commit("setErrorState", {
          type: "manualApproval",
          error: { hasError: false, status: rawData.status, message: rawData.statusText }
        });
      } else {
        data = await rawData.json();
      }

      dispatch("retrieveNotificationDetails");
      commit("setManualStatus", data);
      commit("setErrorState", { type: "manualApproval", error: "" });
      commit("setLoadingState", { type: "manualApproval", value: false });
    } catch (error) {
      commit("setManualStatus", []);
      commit("setErrorState", { type: "manualApproval", error });
      commit("setLoadingState", { type: "manualApproval", value: false });
    }
  },
  retrieveNotificationDetails({ dispatch }) {
    const params = {
      complianceId: state.compId,
      compliancePort: state.compPort,
      complianceType: state.complianceType,
      vesselCode: state.vesselCode,
      voyageCode: state.voyageCode,
      loadPort: state.loadPort
    };

    dispatch("fetchNotificationDetails", params);
  },
  /*Action to update the  view type of Manifest ex:: list, detail*/
  async updateManifestViewType({ commit }, value) {
    commit("setManifestViewType", value);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
